module.exports = __webpack_public_path__ + "static/img/about-banner.abdaa6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-banner.jpg
// module id = 286
// module chunks = 2